import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
} from "@mui/material";

import MuiHeader from "../../components/MuiHeader";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const TokenManagement = () => {
  const [tokens, setTokens] = useState([
    { id: 1, name: "p puja", userType: "CCI", tokenCode: "12345", createdAt: "2025-01-15" },
    { id: 2, name: "Sasmita", userType: "School", tokenCode: "67890", createdAt: "2025-01-16" },
    { id: 3, name: "S Das", userType: "CCI", tokenCode: "54321", createdAt: "2025-01-17" },
    { id: 4, name: "Priyanka", userType: "School", tokenCode: "98765", createdAt: "2025-01-18" },
    { id: 5, name: "John", userType: "CCI", tokenCode: "11223", createdAt: "2025-01-19" },
    { id: 6, name: "Jane", userType: "School", tokenCode: "44556", createdAt: "2025-01-20" },
    { id: 7, name: "Mike", userType: "CCI", tokenCode: "77889", createdAt: "2025-01-21" },
    { id: 8, name: "Alice", userType: "School", tokenCode: "99001", createdAt: "2025-01-22" },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState("All");
  const [visibleTokens, setVisibleTokens] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const toggleVisibility = (index) => {
    setVisibleTokens((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const formatDateTime = (dateTime) => {
    const dateObj = new Date(dateTime);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return { date, time };
  };

  const filteredTokens = tokens.filter((token) => {
    const matchesName = token.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = filter === "All" || token.userType === filter;
    return matchesName && matchesFilter;
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <MuiHeader header="Token Code" />
      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <TextField
            label="Search by Name"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth
            style={{ flex: "1 1 100px", minWidth: "10px", maxWidth: "150px" }}
          />
          <Select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            displayEmpty
            fullWidth
            style={{ flex: "1 1 100px", minWidth: "100px", maxWidth: "150px" }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="CCI">CCI</MenuItem>
            <MenuItem value="School">School</MenuItem>
          </Select>
        </div>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Token Id</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>User Type</TableCell>
                <TableCell>Token Code</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTokens
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((token, index) => {
                  const { date, time } = formatDateTime(token.createdAt);
                  return (
                    <TableRow key={index}>
                      <TableCell>{token.id}</TableCell>
                      <TableCell>{token.name}</TableCell>
                      <TableCell>{token.userType}</TableCell>
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {visibleTokens[index] ? token.tokenCode : "*****"}
                          <IconButton
                            size="small"
                            onClick={() => toggleVisibility(index)}
                            aria-label={
                              visibleTokens[index]
                                ? "Hide token code"
                                : "Show token code"
                            }
                          >
                            {visibleTokens[index] ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </div>
                      </TableCell>
                      <TableCell>{date}</TableCell>
                      <TableCell>{time}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={filteredTokens.length}
            page={page}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </TableContainer>
      </div>
    </>
  );
};

export default TokenManagement;
